import { useQuery } from '@tanstack/react-query';
import type { WeatherCurrent } from '@/types/weather';
import { REFRESH_INTERVALS } from '../constants';

export function useWeather() {
  return useQuery({
    queryKey: ['weather', 'current'],
    queryFn: async (): Promise<WeatherCurrent | null> => {
      const res = await fetch('/api/weather/current');
      if (!res.ok) return null; // Weather is optional
      return res.json();
    },
    refetchInterval: REFRESH_INTERVALS.current,
    staleTime: 30000,
  });
}
